// extracted by mini-css-extract-plugin
export default {"cardContainer":"judge_cardContainer__GDe4t","showCard":"judge_showCard__pPd6Y","editStyle":"judge_editStyle__mbJsu","font20":"judge_font20__tbBwD"};